<template>
  <div class="preloader" v-if="isLoading">
    <div class="preloader-container">
      <div class="thecube">
        <div class="cube c1"></div>
        <div class="cube c2"></div>
        <div class="cube c4"></div>
        <div class="cube c3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mainMixin from '../mixins/mainMixin'

export default {
  name: 'Preloader',
  mixins: [
    mainMixin
  ],

  watch: {
    isLoading (value) {
      if (value) {
        this.$emit('show-preloader')
      } else {
        this.$emit('hide-preloader')
      }
    }
  }
}
</script>
